import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "tss-react/mui";
import { CircularProgress } from "@mui/material";
import Button from "../CustomButtons/Button";
import { Check, Clear } from "@mui/icons-material";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

const style = {
  progressIcon: {
    marginRight: "8px",
    color: "#ffffff",
  },
};

function SaveButton({ ...props }) {
  const { classes } = props;

  let buttonIcon = props.hasError ? <Clear className={classes.icons} /> : <Check className={classes.icons} />;
  let buttonColor = props.hasError ? "danger" : "success";

  return props.saving ? (
    <Button className={classes.marginRight} color={"success"} disabled>
      <CircularProgress className={classes.progressIcon} size={18} />{" "}
      <TranslationWrapper tDefault={"Bezig"} tKey={"global.savebutton.bezig.text"} />
      ...
    </Button>
  ) : (
    <Button
      className={classes.marginRight}
      color={buttonColor}
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type}
    >
      {buttonIcon} {props.buttonText}{" "}
      {props.tKey.length ? <TranslationWrapper tDefault={props.tDefault} tKey={props.tKey} /> : ""}
    </Button>
  );
}

SaveButton.propTypes = {
  classes: PropTypes.object,
  saving: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  hasError: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
  tKey: PropTypes.string,
  tDefault: PropTypes.string,
};

SaveButton.defaultProps = {
  hasError: false,
  disabled: false,
  buttonText: "Opslaan",
  tKey: "",
  tDefault: "",
};

export default withStyles(SaveButton, style);
